module.exports = __webpack_public_path__ + "static/media/wisdom.db1c3c01.jpg";